'use strict';

var React = require('react');
var classNames = require('classnames');
var BrandFandomLogomark = require('../../assets/BrandFandomLogomark');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var BrandFandomLogomark__default = /*#__PURE__*/_interopDefaultLegacy(BrandFandomLogomark);

const ImageCardHorizontal = ({ altText = '', image, shape = 'square', isImageLazyLoaded = false, }) => {
    const cardImageClass = classNames__default["default"]('card-image-horizontal', {
        'card-image-horizontal--round': shape === 'round',
        'card-image-horizontal--square': shape === 'square',
        'card-image-horizontal--empty': !image,
    });
    return (React__default["default"].createElement("div", { className: cardImageClass }, image ? (React__default["default"].createElement("img", { src: image, alt: altText, loading: isImageLazyLoaded ? 'lazy' : 'eager' })) : (React__default["default"].createElement("div", { className: "wds-image-placeholder" },
        React__default["default"].createElement(BrandFandomLogomark__default["default"], null)))));
};

module.exports = ImageCardHorizontal;
